import { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { process } from "@/data/content";
import { Reveal, SectionLabel } from "./Reveal";

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 80%", "end 60%"] });
  const progress = useSpring(scrollYProgress, { stiffness: 80, damping: 20 });

  return (
    <section id="process" className="bg-white py-24 md:py-32" data-testid="process-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="mb-16 max-w-3xl">
          <SectionLabel index="04">Workflow</SectionLabel>
          <h2 className="text-4xl font-bold leading-[1.05] tracking-[-0.03em] text-[#05325F] sm:text-5xl lg:text-6xl">From curriculum intent to final delivery.</h2>
        </Reveal>
        <div ref={ref} className="relative">
          <div className="absolute left-5 top-0 h-full w-0.5 bg-[#E0E8F2] lg:left-0 lg:top-5 lg:h-0.5 lg:w-full" />
          <motion.div style={{ scaleY: progress }} className="absolute left-5 top-0 h-full w-0.5 origin-top bg-[#005EB8] lg:hidden" />
          <motion.div style={{ scaleX: progress }} className="absolute left-0 top-5 hidden h-0.5 w-full origin-left bg-[#005EB8] lg:block" />
          <ol className="relative grid gap-10 lg:grid-cols-6 lg:gap-6">
            {process.map((s, i) => (
              <Reveal key={s.step} delay={i * 0.08} className="group flex gap-6 lg:block" data-testid={`process-step-${i}`}>
                <span className="relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 border-[#05325F] bg-white text-sm font-bold text-[#05325F] transition-colors duration-300 group-hover:bg-[#05325F] group-hover:text-white">
                  {i + 1}
                </span>
                <div className="lg:mt-8">
                  <h3 className="text-xl font-bold text-[#05325F]">{s.step}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-[#4A607A]">{s.text}</p>
                </div>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
